import { FC } from 'react'
import { useCollabItemContext } from '../CollabItem'
import Collapse from 'react-css-collapse'

export const REPLY_FORM_TRANSITION_DURATION = 250

const ReplyForm: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { isActive } = useCollabItemContext()

  return <Collapse isOpen={isActive}>{children}</Collapse>
}

export { ReplyForm }
